import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Departamento, Empregador, Funcionario } from '../../api.service';
import { BuscaPesquisavelComponent } from '../../shared/busca-pesquisavel.component';
import { SeletorMultiploDepartamentosComponent } from '../../shared/seletor-multiplo-departamentos.component';
import { FormatoExportacao } from './servico-exportacao-ponto';

@Component({
  selector: 'app-painel-filtros-exportacao',
  standalone: true,
  imports: [CommonModule, FormsModule, BuscaPesquisavelComponent, SeletorMultiploDepartamentosComponent],
  templateUrl: './painel-filtros-exportacao.component.html'
})
export class PainelFiltrosExportacaoComponent {
  @Input() empregadores: Empregador[] = [];
  @Input() empregadorSelecionado = '';
  @Input() funcionarioSelecionado = '';
  @Input() departamentoSelecionado: string[] = [];
  @Input() buscaFuncionario = '';
  @Input() departamentos: Departamento[] = [];
  @Input() funcionariosFiltrados: Funcionario[] = [];
  @Input() dataInicial = '';
  @Input() dataFinal = '';
  @Input() formato: FormatoExportacao = 'csv';
  @Input() rotuloFuncionario: (item: unknown) => string = () => '';
  @Input() detalheFuncionario: (item: unknown) => string = () => '';

  @Output() empregadorSelecionadoChange = new EventEmitter<string>();
  @Output() buscaFuncionarioChange = new EventEmitter<string>();
  @Output() departamentoSelecionadoChange = new EventEmitter<string[]>();
  @Output() dataInicialChange = new EventEmitter<string>();
  @Output() dataFinalChange = new EventEmitter<string>();
  @Output() formatoChange = new EventEmitter<FormatoExportacao>();
  @Output() abrirModalFuncionarios = new EventEmitter<void>();
  @Output() selecionarFuncionario = new EventEmitter<unknown>();
  @Output() limparResultado = new EventEmitter<void>();
  @Output() pesquisar = new EventEmitter<void>();
  @Output() limpar = new EventEmitter<void>();
  @Output() gerar = new EventEmitter<void>();
  @Output() acertoServidor = new EventEmitter<void>();
  @Output() acertoGeral = new EventEmitter<void>();

  alterarDataInicial(valor: string) {
    this.dataInicialChange.emit(valor);
    this.limparResultado.emit();
  }

  alterarDataFinal(valor: string) {
    this.dataFinalChange.emit(valor);
    this.limparResultado.emit();
  }

  alterarDepartamento(valor: string[]) {
    this.departamentoSelecionadoChange.emit(valor);
    this.limparResultado.emit();
  }
}
